import React from 'react';
import Header from '../../Components/Header';
import HotelSearch from './HotelSearch';

const Hotel = () => (
  <>
    <Header></Header>
    <section className='Hotel_top_banner'>
      <HotelSearch />
    </section>
<section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Delhi.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Delhi</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Mumbai.png" alt="flight" class="img-fluid" />
                </div>
                    <h5> Mumbai</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Bangalore.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Bangalore</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/NewYork.png" alt="flight" class="img-fluid" />
                </div>
                    <h5> New York</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Singapore.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Singapore</h5>
                </a>
            </div>
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
    {/* <div class="escapes-section">
      <div class="container">
        <div class="_toprflcont">
			<div class="_hdrtxt">Book Hotels For Every Mood </div>
		</div>
        <div class="col-md-12 escapes-header">
          <p>Curated Escapes for Your Curious Soul!</p>
        </div>
        <div className='row'>
          <div className='col-md-3 col-lg-3'>
            <a href='/'>
              <div className='image_se'>
                <img src='/assets/images/hotel/mountain-sec.jpg' alt="hotel"></img>
              </div>
              <div className='text_for'>
                <h3>Mountains Calling</h3>
                <p>Explore More <i className='fa fa-arrow-right'></i></p>
              </div>
            </a>
          </div>
          <div className='col-md-3 col-lg-3'>
            <a href='/'>
              <div className='image_se'>
                <img src='/assets/images/hotel/beach-sec.jpg' alt="hotel"></img>
              </div>
              <div className='text_for'>
                <h3>Beach Vacations</h3>
                <p>Explore More <i className='fa fa-arrow-right'></i></p>
              </div>
            </a>
          </div>
          <div className='col-md-3 col-lg-3'>
            <a href='/'>
              <div className='image_se'>
                <img src='/assets/images/hotel/weekend-sec.jpg' alt="hotel"></img>
              </div>
              <div className='text_for'>
                <h3>Weekend Getaways</h3>
                <p>Explore More <i className='fa fa-arrow-right'></i></p>
              </div>
            </a>
          </div>
          <div className='col-md-3 col-lg-3'>
            <a href='/'>
              <div className='image_se'>
                <img src='/assets/images/hotel/monsoon-sec.jpg' alt="hotel"></img>
              </div>
              <div className='text_for'>
                <h3>Monsoon Magic</h3>
                <p>Explore More <i className='fa fa-arrow-right'></i></p>
              </div>
            </a>
          </div>

        </div>

      </div>
    </div> */}

  </>

);

export default Hotel;
